
import { format } from "date-fns";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Project } from "@/types/Project";

interface SummaryCardsProps {
  totalHours: number;
  totalRevenue: number;
  selectedProject: string;
  selectedMonth: Date;
  selectedProjectData: Project | null;
}

export function SummaryCards({ totalHours, totalRevenue, selectedProject, selectedMonth, selectedProjectData }: SummaryCardsProps) {
  const clientInfo = selectedProjectData?.invoiceSettings ?? null;

  return (
    <div className="grid gap-4 md:grid-cols-3">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">
            Total Hours
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalHours.toFixed(1)}</div>
          <p className="text-xs text-muted-foreground">
            For {format(selectedMonth, "MMMM yyyy")}
          </p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">
            Total Revenue
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            ${totalRevenue.toFixed(2)}
          </div>
          <p className="text-xs text-muted-foreground">
            Based on project hourly rates
          </p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">
            Client Info
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-sm font-medium">
            {clientInfo?.clientName || (selectedProject === "all" ? "Multiple Clients" : "No client info")}
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            {clientInfo?.clientEmail || "No email specified"}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
